import { useForm } from 'react-hook-form';
import { message } from 'antd';
import { useState } from 'react';
import registerService from './useRegisterService';

export function useRegister() {
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    getValues,
    formState: { errors },
  } = useForm();

  const error = (content) => {
    message.open({
      type: 'error',
      content: content,
      className: 'custom-class',
      style: {
        marginTop: '15vh',
      },
    });
  };


  const onSubmit = async (data) => {
    const formData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
      telephone: data.telephone,
    };
    setLoading(true);
    try {
      const res = await registerService.register(formData);
      localStorage.setItem("accessToken", res.data.accessToken);
      localStorage.setItem("refreshToken", res.data.refreshToken);
      window.location.href = "/";
    } catch (err) {
      console.error('Login error:', err);
      const notAllowedDomainEmails = err?.response?.data?.message.includes('email_domain_not_allowed');
      if (notAllowedDomainEmails) {
        error("Email domain not allowed");
      } else {
        error("log in error, check your credentials");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    register,
    errors,
    onSubmit,
    loading,
    getValues
  };
}